<template>
  <div class="hzc-discuss">
    <div style="height: 623px;position: relative;">
      <div>
        <div class="box" id="waiceng">
          <div id="neiwaiceng">
            <div class="content" v-if="bulletinList.length > 0">
              <ul>
                <li v-for="(item, index) in bulletinList" :key="index">
                  <img src="../../assets/images/touxiang.png" alt="">
                  <div class="content-head">
                    <div class="name">{{ item.createBy }}</div>
                    <div class="time">{{ item.createTime }}</div>
                  </div>
                  <div class="text">
                    {{ item.speakText }}
                  </div>
                </li>
              </ul>
            </div>
            <div class="no-text" v-else>
              <img src="../../assets/images/kanfa.png" alt="">
              <p>请发表您的看法...</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <textarea v-model="text" id="" maxlength="300" placeholder="请输入您的看法" cols="30" rows="3"></textarea>
        <button class="btn" @click="addBtn">
          发送
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {addBulletin, bulletinList} from "@/api/coke";

export default {
  data() {
    return {
      bulletinList: [],
      text: '',
    }
  },
  props:[
      'sourceType'
  ],
  created() {
    this.getBulletin()
  },
  methods: {
    /**
     * 获取讨论区
     */
    getBulletin() {
      bulletinList({sourceType: this.sourceType}).then(res => {
        this.bulletinList = res.data;
        this.setScroll()
      })
    },
    setScroll() {
      setTimeout(() => {
        this.$nextTick(() => {
          const waiceng = document.getElementById('waiceng');
          const neiwaiceng = document.getElementById('neiwaiceng');
          waiceng.scrollTop = neiwaiceng.clientHeight;
        })
      }, 200)
    },
    /**
     * 新增讨论区
     */
    addBtn() {
      if (!this.text) {
        this.$message.error('请输入内容')
        return;
      }
      addBulletin({sourceType: this.sourceType, speakText: this.text}).then(() => {
        this.$message.success('留言成功！')
        this.text = '';
        this.getBulletin();
      })
    },
  }
}
</script>

<style lang="less" scoped>
.hzc-discuss {
  z-index: 101;
  width: 980px;
  //height: 680px;
  //position: absolute;
  //top: 50%;
  //left: 50%;
  //margin-left: -490px;
  //margin-top: -340px;
  background-color: #fff;

  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .head {
    z-index: 103;
    font-size: 18px;
    color: #222;
    height: 53px;
    background: #F2F2F2;
    line-height: 53px;
    position: absolute;
    top: 0;
    left: 0;
    width: 980px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    p {
      margin-left: 25px;
      display: inline-block;
    }

    img {
      width: 15px;
      float: right;
      margin-top: 18px;
      margin-right: 24px;
      cursor: pointer;
    }
  }

  .box {
    z-index: 101;
    width: 980px;
    height: 488px;
    padding-top: 10px;
    background-color: #fff;
    overflow: auto;

    .content {
      margin-left: 24px;

      ul {
        li {
          margin-right: 25px;
          border-bottom: 1px solid #ccc;
          padding-bottom: 25px;
          margin-top: 25px;


          img {
            width: 20px;
            vertical-align: top;
          }

          .content-head {
            margin-left: 6px;
            width: 890px;
            display: inline-block;
            vertical-align: top;

            .name {
              display: inline-block;
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #777777;
              line-height: 17px;
            }

            .time {
              float: right;
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #777777;
              line-height: 17px;
            }
          }

          .text {
            width: 906px;
            margin-left: 27px;
            margin-top: 4px;
            color: #222;
            line-height: 20px;
            font-size: 14px;
            word-break: break-all;
          }
        }

        li:last-child {
          border-bottom: none;
        }
      }
    }

    .no-text {
      width: 180px;
      margin-left: -90px;
      position: absolute;
      left: 50%;
      top: 43%;
      margin-top: -70px;

      img {
        width: 180px;
      }

      p {
        color: #999999;
        text-align: center;
      }
    }
  }

  .footer {
    height: 56px;
    padding: 16px 48px;
    margin-top: 534px;
    background: #fff;
    border-top: 1px solid #ccc;
    position: absolute;
    bottom: 0;
    z-index: 103;

    textarea {
      width: 798px;
      resize: none;
      border-bottom-left-radius: 4px;
      background-color: #f2f2f2;
      border-top-left-radius: 4px;
      outline: none
    }

    .btn {
      display: inline-block;
      width: 80px;
      height: 51px;
      background: #D3131A;
      text-align: center;
      line-height: 51px;
      color: #fff;
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
      vertical-align: top;
      cursor: pointer;
      border: none;
    }
  }
}
</style>
